import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { PRValidationReport } from "../components";
class PRValidationReportContainer extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "report",
            title: "PR Validation & Run ID Closure Report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "PR Validation & Run ID Closure Report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <PRValidationReport />
            </Base>
        );
    }
}

export default PRValidationReportContainer;
